import urlcat from "urlcat";

import { axiosInstance, parseResponse, TENANT_API_URL } from "..";

const TASK_MANAGEMENT = `${TENANT_API_URL}/task-management`;

const stringifyQueryValue = (value: unknown) =>
  value instanceof Date ? value.toISOString() : String(value);

/**
 * Repeated keys keep large arrays as arrays in the API query parser. Indexed
 * keys such as tasks[20] cross its default array-index limit and are parsed as
 * an object instead, which cannot be cast to a task ObjectId.
 */
export const buildTaskManagementQueryUrl = (
  baseUrl: string,
  data: Record<string, unknown>
) => {
  const params = new URLSearchParams();

  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null) {
          params.append(key, stringifyQueryValue(item));
        }
      });
      return;
    }

    params.append(key, stringifyQueryValue(value));
  });

  const query = params.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
};

export const getVisitTasks = async (data: Record<string, unknown>) => {
  try {
    const url = urlcat(`${TASK_MANAGEMENT}/roster-visit-tasks`, data);
    const response = await axiosInstance.get(url);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getTasksStatusCount = async () => {
  try {
    const response = await axiosInstance.get(
      `${TASK_MANAGEMENT}/dashboard-tasks-count`
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getTODOTasks = async (data: any) => {
  try {
    const url = buildTaskManagementQueryUrl(`${TASK_MANAGEMENT}/to-do`, data);
    const response = await axiosInstance.get(url);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getAllTasks = async (data: any) => {
  try {
    const url = urlcat(`${TASK_MANAGEMENT}`, data);
    // logger.debug('urlllll',url)
    const response = await axiosInstance.get(url);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getTasks = async (urlWithFilters: any) => {
  try {
    const response = await axiosInstance.get(urlWithFilters);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getTaskById = async <T>(id: string) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.get<T>(`${TASK_MANAGEMENT}/${id}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const createTask = async (data: Record<string, unknown>) => {
  try {
    const response = await axiosInstance.post(`${TASK_MANAGEMENT}`, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updateTask = async (
  id: string | undefined | null,
  data: Record<string, unknown>
) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.put(`${TASK_MANAGEMENT}/${id}`, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const deleteTask = async (id: string) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.delete(`${TASK_MANAGEMENT}/${id}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
